import Controller from './Controller';
import type Report from '../checks/Report';
import { CEMC_FSM, CEMC_SelectFSM } from '../commands/metamodel/complex';
import { Combined_DeleteFSM } from '../commands/combined';
import type { OrId, FSMUpdates } from '../commands/types';
import type { IObjectType } from '../../stores/model/metamodel/object_type';
import type { IFSM } from '../../stores/model/metamodel/fsm';

/**
 * Edit an FSM
 */
export default class EditFSMController extends Controller {
  /**
   * Edit the properties of an FSM.
   */
  async editFSM(
    objectId: OrId<IObjectType>,
    fsmId: OrId<IFSM>,
    updates: FSMUpdates
  ): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = CEMC_FSM(model, objectId, fsmId, updates);
      return checks;
    });
  }

  /**
   * Select an FSM for code generation.
   */
  async selectFSMForCodeGeneration(
    objectId: OrId<IObjectType>,
    fsmId: OrId<IFSM>
  ): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = CEMC_SelectFSM(model, objectId, fsmId);
      return checks;
    });
  }

  /**
   * Delete an FSM
   */
  async deleteFSM(objectId: OrId<IObjectType>, fsmId: OrId<IFSM>): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = Combined_DeleteFSM(model, objectId, fsmId);
      return checks;
    });
  }
}
